import { Box } from "@mui/material";
import { useState } from "react";
import { SaleRequest } from "../../service/model/store.model";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import * as saleSlice from "../../features/store/sales/sale.slice";
import Loader from "../../components/loader";
import useSales from "../../hooks/use-sales";
import { selectLoggedInUser } from "../../features/auth/auth.slice";
import SaleTable from "../../features/store/sales/components/sale-table";
import SaleForm from "../../features/store/sales/components/sale-form";
import SaleSummary from "../../features/store/sales/components/sale-summary";
import CreateButton from "../../components/create-button";

const Sales = () => {
    const dispatch = useAppDispatch();
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;
    const [showSaleForm, setShowSaleForm] = useState(false);
    const isLoading = useAppSelector(saleSlice.selectIsLoading);

    const [sales] = useSales();

    const handleSubmit = (data: SaleRequest) => {
        loggedInUser && dispatch(saleSlice.createSale({ ...data, })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowSaleForm(false);
            }
        });
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {sales &&
                <>
                    <SaleSummary />
                    <Box sx={{ mb: "12px" }}>
                        <CreateButton variant="contained" onClick={() => setShowSaleForm(true)} style={{ marginBottom: "12px", marginTop: "12px" }}>Add Sale</CreateButton>
                    </Box>
                    <SaleTable sales={sales} />
                    {showSaleForm &&
                        <SaleForm sale={undefined} editable={true} onClose={() => setShowSaleForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default Sales;